module.exports = __webpack_public_path__ + "img/small-owl_1.5a8dcd09.jpg";